import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-empty',
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent {
  @Input() title: string;

}
